export const Haptic: Haptic = {
	selection: () => undefined,
	success: () => undefined,
};
